/**
 * Model to hold Permission data with the resource name from identity
 */
export class IdentityPermissionName {
    public id: string = null;
    public userId: string = null;
    public resourceType: string = null;
    public resourceId: string = null;
    public resourceName: string = null;
    public action: string = null;

    public clone(): IdentityPermissionName {
        const clone: IdentityPermissionName = new IdentityPermissionName();
        clone.id = this.id;
        clone.userId = this.userId;
        clone.resourceId = this.resourceId;
        clone.resourceName = this.resourceName;
        clone.resourceType = this.resourceType;
        clone.action = this.action;

        return clone;
    }

    public deserialize(json: any): IdentityPermissionName {
        this.id = json.id;
        this.userId = json.userId;
        this.resourceType = json.resourceType;
        this.resourceId = json.resourceId;
        this.resourceName = json.resourceName;
        this.action = json.action;

        return this;
    }
}
